import { render, staticRenderFns } from "./SNotification.vue?vue&type=template&id=e6574aaa&scoped=true"
import script from "./sNotification.ts?vue&type=script&lang=ts&external"
export * from "./sNotification.ts?vue&type=script&lang=ts&external"
import style0 from "./SNotification.vue?vue&type=style&index=0&id=e6574aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6574aaa",
  null
  
)

export default component.exports